var map = {
	"./Pattern.png": 83484,
	"./Vedam/DILogo.png": 97967,
	"./Vedam/DILogoBig.png": 90707,
	"./Vedam/Ellipse.png": 35960,
	"./Vedam/NewDILogoPNG.png": 62761,
	"./Vedam/NewDILogoPNG100.png": 68844,
	"./Vedam/Vedam.png": 93974,
	"./Vedam/VedamLogo.png": 72653,
	"./Vedam/VideoPlay.jpg": 14118,
	"./Vedam/clipboard.png": 93716,
	"./Vedam/fileimg.png": 87902,
	"./Vedam/logo.png": 12774,
	"./Vedam/newDILogo.svg": 74085,
	"./Vedam/pdf.png": 19794,
	"./Vedam/ship2.png": 66077,
	"./Vedam/user.png": 81372,
	"./Vedam/vedamL.png": 72726,
	"./Vedam/word.png": 30262,
	"./Vedam/xls.png": 58899,
	"./ajax-loader.gif": 586,
	"./attachment-1.jpg": 45078,
	"./attachment-2.jpg": 95906,
	"./attachment-3.jpg": 74482,
	"./avtar/1.jpg": 54073,
	"./avtar/11.jpg": 12974,
	"./avtar/16.jpg": 32896,
	"./avtar/3.jpg": 99983,
	"./avtar/4.jpg": 22823,
	"./avtar/6.jpg": 21120,
	"./avtar/7.jpg": 96788,
	"./avtar/8.jpg": 66305,
	"./banner/1.jpg": 38421,
	"./banner/3.jpg": 39214,
	"./big-lightgallry/01.jpg": 15538,
	"./big-lightgallry/012.jpg": 62862,
	"./big-lightgallry/013.jpg": 3131,
	"./big-lightgallry/014.jpg": 60282,
	"./big-lightgallry/015.jpg": 75359,
	"./big-lightgallry/016.jpg": 85073,
	"./big-lightgallry/02.jpg": 49381,
	"./big-lightgallry/03.jpg": 9595,
	"./big-lightgallry/04.jpg": 97459,
	"./big-lightgallry/05.jpg": 41154,
	"./big-lightgallry/06.jpg": 76476,
	"./big-lightgallry/07.jpg": 6894,
	"./big-lightgallry/08.jpg": 70598,
	"./bitcoin/1.png": 73525,
	"./bitcoin/2.png": 73020,
	"./bitcoin/3.png": 51797,
	"./bitcoin/chat-1.jpg": 61597,
	"./bitcoin/chat-2.jpg": 41042,
	"./bitcoin/market-1.jpg": 66953,
	"./bitcoin/market-2.jpg": 97643,
	"./bitcoin/market-3.jpg": 35566,
	"./bitcoin/market-4.jpg": 65584,
	"./blog/12.png": 40687,
	"./blog/14.png": 85765,
	"./blog/4.jpg": 19379,
	"./blog/9.jpg": 91219,
	"./blog/blog-2.jpg": 8478,
	"./blog/blog-3.jpg": 15301,
	"./blog/blog-4.jpg": 60383,
	"./blog/blog-5.png": 8690,
	"./blog/blog-6.png": 14381,
	"./blog/blog-single.jpg": 51029,
	"./blog/blog.jpg": 2621,
	"./blog/comment.jpg": 18560,
	"./blog/img.png": 67056,
	"./c1.jpg": 64296,
	"./c2.jpg": 57840,
	"./c3.jpg": 34509,
	"./camera.png": 80193,
	"./checkout/paypal.png": 61938,
	"./close-icon.png": 19638,
	"./codecanyon.png": 59320,
	"./dashboard/boy-2.png": 60775,
	"./dashboard/browser.png": 20790,
	"./dashboard/chrome.png": 98460,
	"./dashboard/designer.jpg": 49472,
	"./dashboard/firefox.png": 79110,
	"./dashboard/folder.png": 24864,
	"./dashboard/folder1.png": 86355,
	"./dashboard/notification.png": 23331,
	"./dashboard/safari.png": 58287,
	"./dashboard/search.png": 11448,
	"./dashboard/ship.png": 94156,
	"./dashboard/smily.png": 6642,
	"./dashboard/translate.png": 84217,
	"./dashboard/user.png": 68412,
	"./dashboard/whether.png": 95896,
	"./ecommerce/01 - Copy.jpg": 87012,
	"./ecommerce/01.jpg": 81160,
	"./ecommerce/02.jpg": 5531,
	"./ecommerce/03.jpg": 37041,
	"./ecommerce/04.jpg": 44122,
	"./ecommerce/05.jpg": 54542,
	"./ecommerce/06.jpg": 91660,
	"./ecommerce/07.jpg": 62823,
	"./ecommerce/08.jpg": 12614,
	"./ecommerce/09.jpg": 17829,
	"./ecommerce/10.jpg": 53725,
	"./ecommerce/11.jpg": 65201,
	"./ecommerce/12.jpg": 3704,
	"./ecommerce/banner.jpg": 67250,
	"./ecommerce/card.png": 74411,
	"./ecommerce/mastercard.png": 97680,
	"./ecommerce/paypal.png": 96405,
	"./ecommerce/product-table-1.png": 57109,
	"./ecommerce/product-table-2.png": 1463,
	"./ecommerce/product-table-3.png": 50741,
	"./ecommerce/product-table-4.png": 96563,
	"./ecommerce/product-table-5.png": 14305,
	"./ecommerce/product-table-6.png": 22063,
	"./ecommerce/visa.png": 28662,
	"./email/1.jpg": 28201,
	"./email/2.jpg": 88010,
	"./email/3.jpg": 89787,
	"./endless-logo.png": 15580,
	"./faq/1.jpg": 22963,
	"./faq/2.jpg": 32051,
	"./faq/3.jpg": 78070,
	"./faq/4.jpg": 98505,
	"./faq/learning-1.png": 69142,
	"./favicon.png": 90946,
	"./hour.svg": 77154,
	"./icon-empty-cart.png": 290,
	"./job-search/1.jpg": 47953,
	"./job-search/2.jpg": 17924,
	"./job-search/3.jpg": 8612,
	"./job-search/4.jpg": 72554,
	"./job-search/5.jpg": 53515,
	"./job-search/6.jpg": 22886,
	"./lightgallry/01.jpg": 88517,
	"./lightgallry/010.jpg": 69077,
	"./lightgallry/011.jpg": 86078,
	"./lightgallry/012.jpg": 91838,
	"./lightgallry/013.jpg": 87194,
	"./lightgallry/014.jpg": 32671,
	"./lightgallry/015.jpg": 10277,
	"./lightgallry/016.jpg": 20246,
	"./lightgallry/02.jpg": 23438,
	"./lightgallry/03.jpg": 34220,
	"./lightgallry/04.jpg": 93333,
	"./lightgallry/05.jpg": 78721,
	"./lightgallry/06.jpg": 31033,
	"./lightgallry/07.jpg": 67886,
	"./lightgallry/08.jpg": 2880,
	"./lightgallry/09.jpg": 16995,
	"./logo-light.png": 12007,
	"./logo/compact-logo.png": 78772,
	"./logo/techLogo.png": 37663,
	"./masonry/1.jpg": 58104,
	"./masonry/10.jpg": 52367,
	"./masonry/11.jpg": 50092,
	"./masonry/12.jpg": 76075,
	"./masonry/13.jpg": 17762,
	"./masonry/14.jpg": 49701,
	"./masonry/15.jpg": 21363,
	"./masonry/2.jpg": 5362,
	"./masonry/3.jpg": 58973,
	"./masonry/4.jpg": 46979,
	"./masonry/5.jpg": 58742,
	"./masonry/6.jpg": 14516,
	"./masonry/7.jpg": 13143,
	"./masonry/8.jpg": 82839,
	"./masonry/9.jpg": 85544,
	"./min.svg": 45470,
	"./other-images/auth-bg-1.jpg": 11291,
	"./other-images/auth-bg.jpg": 85610,
	"./other-images/auth-layer.png": 59972,
	"./other-images/bg-profile.png": 59262,
	"./other-images/calender-bg.png": 6163,
	"./other-images/caller.jpg": 95706,
	"./other-images/clock-face.png": 69616,
	"./other-images/cloud-bg-1.png": 49721,
	"./other-images/cloud-bg-2.png": 52817,
	"./other-images/coming-soon-Logo.png": 84780,
	"./other-images/coming-soon-bg.jpg": 45067,
	"./other-images/img-cropper.jpg": 22614,
	"./other-images/key.png": 57717,
	"./other-images/login-3.jpg": 72245,
	"./other-images/login-4.jpg": 88363,
	"./other-images/logo-login.png": 74704,
	"./other-images/maintenance-bg.jpg": 94842,
	"./other-images/mobile-clock-wallpaper.jpg": 71371,
	"./other-images/open-lock.png": 33797,
	"./other-images/paypal.png": 1045,
	"./other-images/profile-style-img.png": 64342,
	"./other-images/profile-style-img3.png": 28926,
	"./other-images/receiver-img.jpg": 59409,
	"./other-images/sad.png": 32122,
	"./other-images/sidebar-bg.jpg": 50509,
	"./product/1.png": 94785,
	"./product/10.png": 75663,
	"./product/11.png": 2340,
	"./product/12.png": 7277,
	"./product/13.png": 56061,
	"./product/14.png": 91336,
	"./product/15.png": 63358,
	"./product/2.png": 59747,
	"./product/3.png": 54470,
	"./product/4.png": 84792,
	"./search-not-found.png": 28856,
	"./sec.svg": 96702,
	"./secondhandm.png": 41467,
	"./server/hexgon.jpg": 48199,
	"./sidebar-image/1.jpg": 33831,
	"./sidebar-image/2.jpg": 39193,
	"./sidebar-image/3.jpg": 13399,
	"./sidebar-image/4.jpg": 51352,
	"./sidebar-image/5.jpg": 76394,
	"./sidebar-image/6.jpg": 90338,
	"./sidebar-pattern/1.png": 80891,
	"./sidebar-pattern/2.png": 30003,
	"./sidebar-pattern/3.png": 14667,
	"./sidebar-pattern/4.png": 71675,
	"./sidebar-pattern/5.png": 37521,
	"./sidebar-pattern/6.png": 78695,
	"./sidebar_images/checklist.png": 58256,
	"./sidebar_images/com_check.png": 65563,
	"./sidebar_images/dashboard.png": 25847,
	"./sidebar_images/globe.png": 88714,
	"./sidebar_images/info.png": 19255,
	"./sidebar_images/profile.png": 32167,
	"./sidebar_images/settings.png": 13814,
	"./sidebar_images/soc.png": 45417,
	"./sidebar_images/steering.png": 30663,
	"./sidebar_images/survey.png": 7357,
	"./slider/1.jpg": 19376,
	"./slider/10.jpg": 97818,
	"./slider/11.jpg": 15101,
	"./slider/12.jpg": 46287,
	"./slider/13.jpg": 84766,
	"./slider/14.jpg": 84410,
	"./slider/2.jpg": 24658,
	"./slider/3.jpg": 33013,
	"./slider/4.jpg": 47661,
	"./slider/5.jpg": 8941,
	"./slider/6.jpg": 86494,
	"./slider/7.jpg": 32777,
	"./slider/8.jpg": 1619,
	"./slider/9.jpg": 83778,
	"./smiley.png": 30078,
	"./social-app/post-1.png": 92785,
	"./social-app/post-2.png": 6514,
	"./social-app/post-3.png": 16872,
	"./social-app/post-4.png": 59138,
	"./social-app/post-5.png": 79125,
	"./social-app/post-6.png": 21810,
	"./social-app/post-7.png": 646,
	"./social-app/post-8.png": 80131,
	"./social-app/post-9.png": 62039,
	"./social-app/social-image.png": 71489,
	"./social-app/timeline-1.png": 41858,
	"./social-app/timeline-2.png": 97900,
	"./social-app/timeline-3.png": 21176,
	"./social-app/timeline-4.png": 11023,
	"./start-conversion.jpg": 60533,
	"./university/bio-1.jpg": 91403,
	"./university/bio-2.jpg": 1539,
	"./university/chart-1.png": 89269,
	"./university/chart-2.png": 82424,
	"./university/chart-3.png": 95170,
	"./university/chart-4.png": 86398,
	"./university/math-1.jpg": 49989,
	"./university/math-2.jpg": 9572,
	"./university/round.png": 57083,
	"./user-card/1.jpg": 2575,
	"./user-card/2.jpg": 32098,
	"./user-card/3.jpg": 31526,
	"./user-card/4.jpg": 75552,
	"./user-card/5.jpg": 29711,
	"./user-card/6.jpg": 14646,
	"./user-card/7.jpg": 35258,
	"./user/1.jpg": 59605,
	"./user/10.jpg": 93604,
	"./user/11.png": 98575,
	"./user/12.png": 68670,
	"./user/14.png": 99018,
	"./user/15.png": 5544,
	"./user/16.png": 78990,
	"./user/2.png": 54810,
	"./user/3.jpg": 95655,
	"./user/3.png": 88441,
	"./user/4.jpg": 35809,
	"./user/5.jpg": 98570,
	"./user/6.jpg": 60704,
	"./user/7.jpg": 76122,
	"./user/8.jpg": 74370,
	"./user/9.jpg": 30792,
	"./user/user.png": 873,
	"./video.png": 66178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;